<template><div class="d-flex justify-center">

<div style="max-width: 900px">
	<v-card>
		 <v-card-title>
	      {{ $t('Combinations') }}
	      <v-spacer></v-spacer>
	      <v-text-field
	        v-model="search"
	        :append-icon="$mdi.Magnify"
	        label="Search"
	        single-line
	        hide-details
	      ></v-text-field>
	    </v-card-title>

		<v-data-table
			:search="search"
			:headers="headers"
			:items="words"
			:items-per-page="10"
			class="elevation-1"
		>
		    <template v-slot:item.nao="{ item }">
		    	<nao pronounce no_popover :o="item.nao" />
				<v-btn
			    	v-if="$nao.disassemble(item.nao).length > 1"
			    	@click="$show_disassemble(item.nao)"
			    	icon
			    ><v-icon> {{ $mdi.TableSplitCell }} </v-icon></v-btn>
		    </template>
		    <template v-slot:item.other_tr="{ item }">
		    	{{ item.other_tr ? item.other_tr.join('; ') : '' }}
		    </template>
		</v-data-table>
	</v-card>
</div>

</div></template>

<script>

import nao from '@/components/Naoword'

export default {
	components: {nao},
	data() {
		return {
			search: '',
			//words: [],
		}
	},
	methods: {

	},
	computed: {
		words() {
			let k = this.$store.state.language;
			return this.$nao.get_all_words_array();
		}
	},
	created() {
		this.headers = [
			{ text: this.$t('Word'), value: 'nao' },
			{ text: this.$t('Meaning'), value: 'main_tr', width: 200 },
			{ text: this.$t('Possible translations'), value: 'other_tr', width: 200 },
		];
	}
}
</script>
